module.exports = "/img/city-ny.b26bae94.jpg";